import React, { useState, useEffect, useCallback } from 'react'
import './ticket-list.less'
import { setHeader } from '@/util/set-header'
import ReactDOM from 'react-dom'
import { ticketListApi } from '@/api/repair'
import TicketItem from '@/pages/repair/ticket-list/ticket-item/ticket-item'
import {
  ListView,
  Toast,
  PullToRefresh,
  ActivityIndicator,
  Result,
} from 'antd-mobile'
import { withRouter } from 'react-router'
const APullToRefresh: any = PullToRefresh
let dataBlobs: any = {}
let sectionIDs = ['0']
let rowIDs: any = [[]]
let page = 1
let el!: ListView
const Footer = ({ isLoading, isHasMore, dataSource }: any) => {
  if (!isHasMore) {
    if (dataSource._cachedRowCount > 0) {
      return <div className="text-center">没有更多啦</div>
    } else {
      return (
        <Result
          img={<img src="/public/assets/img/error.png" alt="" />}
          message={<div>哎呀！暂无通知消息~</div>}
        />
      )
    }
  }
  return (
    <div className="flex-lvc">
      {isLoading ? <ActivityIndicator text="加载中..." /> : ''}
    </div>
  )
}

function TicketList() {
  const getRowData = (dataBlob: any, sectionID: any, rowID: any) =>
    dataBlob[rowID]

  const defaultDataSource = new ListView.DataSource({
    getRowData,
    rowHasChanged: (row1: any, row2: any) => row1 !== row2,
    sectionHeaderHasChanged: (s1: any, s2: any) => s1 !== s2,
  })
  const [dataSource, setDataSource] = useState(defaultDataSource)
  const [isLoading, setIsLoading] = useState(false)
  const [isHasMore, setIsHasMore] = useState(true)
  const [store_id, setStore_id] = useState('17')
  const [height, setHeight] = useState(
    (document.documentElement.clientHeight * 3) / 4,
  )
  const [isRefreshing, setIsRefreshing] = useState(false)
  const separator = (sectionID: any, rowID: any) => (
    <div
      key={`${sectionID}-${rowID}`}
      style={{
        backgroundColor: '#F5F5F9',
        height: 15,
      }}
    />
  )
  //获取列表数据
  const genData = useCallback(async (page: number, id: string) => {
    let params = {
      page,
      store_id: id,
    }
    Toast.loading('加载中', 0)
    const { data } = await ticketListApi(params)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    const orderList = data.data
    setIsHasMore(!data.is_end)
    for (let i = 0; i < orderList.length; i++) {
      let { id } = orderList[i]
      rowIDs[0].push(id)
      dataBlobs[id] = orderList[i]
    }
    setDataSource((dataSource: any) =>
      dataSource.cloneWithRowsAndSections(dataBlobs, sectionIDs, rowIDs),
    )
  }, [])

  useEffect(() => {
    page = 1
    rowIDs = [[]]
    dataBlobs = {}
    const leftClick = () => {
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
    }
    //设置头部
    setHeader({ title: '报修工单', leftClick })
    //请求数据
    // const store_id = '17'
    // genData(page, store_id)

    //获取入住store_id
    window.setPaymentInfo = (argument: string) => {
      let store_id = ''
      if (typeof(argument) === 'string') {
        store_id = JSON.parse(argument).store_id
      } else {
        store_id = argument['store_id']
      }
      setStore_id(store_id)
      genData(page, store_id)
    }
    if (window.WebViewBridge) {
      window.WebViewBridge.userInfo('setPaymentInfo')
    } else if (window.webkit) {
      window.webkit.messageHandlers.userInfo.postMessage('setPaymentInfo')
    }
    //设置高度
    const height =
      document.documentElement.clientHeight -
      (ReactDOM.findDOMNode(el) as any).getBoundingClientRect().top
    setHeight(height)
  }, [genData])
  //上拉加载
  const onEndReached = async (event: any) => {
    if (isLoading || !isHasMore) {
      return false
    }
    await setIsLoading(true)
    page++
    genData(page, store_id)
    setIsLoading(false)
  }
  //下拉刷新
  const onRefresh = async () => {
    if (isLoading) {
      return
    }
    page = 1
    rowIDs = [[]]
    dataBlobs = {}
    setIsLoading(true)
    setIsRefreshing(true)
    await genData(page, store_id)
    setIsRefreshing(false)
    setIsLoading(false)
  }

  return (
    <div className="ticket-list">
      <ListView
        ref={refel => (el = refel as ListView)}
        dataSource={dataSource}
        renderFooter={() => (
          <Footer
            isLoading={isLoading}
            isHasMore={isHasMore}
            dataSource={dataSource}
          />
        )}
        renderRow={info => <TicketItem info={info} />}
        renderSeparator={separator}
        style={{
          height: height,
          overflow: 'auto',
          backgroundColor: '#f5f5f9',
        }}
        onEndReached={e => onEndReached(e)}
        pullToRefresh={
          <APullToRefresh refreshing={isRefreshing} onRefresh={onRefresh} />
        }
      />
    </div>
  )
}

export default withRouter(TicketList)
// export default connect(mapStateToProps)(withRouter(BaseHeader))
